/**
 * Module de filtrage des catégories pour l'archive observatoire
 * Version minimaliste - Seulement le toggle du dropdown
 */

export default {
  name: "archive-observatoire",
};

$(document).ready(function () {
  // Safety check

  if (!document.getElementById("category-toggle-filters")) return;

  this.toggle = document.getElementById("category-toggle-filters");
  this.dropdown = document.getElementById("category-filters");

  if (!this.toggle || !this.dropdown) return;

  // Define click handler
  this.onToggleClick = (e) => {
    e.preventDefault();
    const isExpanded = this.toggle.getAttribute("aria-expanded") === "true";

    if (isExpanded) {
      // Fermer
      this.toggle.setAttribute("aria-expanded", "false");
      this.dropdown.setAttribute("aria-hidden", "true");
      this.toggle.classList.remove("is-active");
      this.dropdown.classList.remove("is-active");
    } else {
      // Ouvrir
      this.toggle.setAttribute("aria-expanded", "true");
      this.dropdown.setAttribute("aria-hidden", "false");
      this.toggle.classList.add("is-active");
      this.dropdown.classList.add("is-active");
    }
  };

  document.body.addEventListener("click", (e) => {
    if (
      !e.target.closest(".filters") &&
      !e.target.classList.contains(".filters")
    ) {
      this.toggle.setAttribute("aria-expanded", "false");
      this.dropdown.setAttribute("aria-hidden", "true");
      this.toggle.classList.remove("is-active");
      this.dropdown.classList.remove("is-active");
    }
  });

  // Add listener manually
  this.toggle.addEventListener("click", this.onToggleClick);

  // Initialiser les attributs ARIA
  this.toggle.setAttribute("aria-expanded", "false");
  this.dropdown.setAttribute("aria-hidden", "true");
});
